import React, { useState, useEffect } from 'react';
import { Form, Button, Select, InputNumber, Slider, Upload, Input, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputRules from '../../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../../store/actions';
import { toFormData } from '../../../util/FormData';

const currentYear = new Date().getFullYear();
const years = [];
for (let i = 0; i <= 10; i++) {
	years.push(currentYear + i);
}
const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 12,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 8,
		span: 16,
	},
};
const uploadButton = (
	<div>
		<PlusOutlined />
		<div style={{ marginTop: 8 }}>Upload</div>
	</div>
);

const VehicleEditForm = ({ utils, fetchVehicleUtils, vehicle, updateVehicleAd, setEditModal, setRefresh }) => {
	const [filelist, setFileList] = useState([]);
	const [imageList, setImageList] = useState([]);

	useEffect(() => {
		fetchVehicleUtils();
	}, []);

	useEffect(() => {
		if (filelist.length) {
			const file = filelist[filelist.length - 1].originFileObj;
			file.thumbUrl = URL.createObjectURL(file);
			const list = imageList;
			list.push(file);
			setImageList(list);
		}
	}, [filelist]);

	const onFinish = (values) => {
		values.user = { _id: vehicle.user._id._id };
		values.images = imageList;
		!values.vehicle.price && (values.vehicle.price = 0);
		!values.vehicle.average && (values.vehicle.average = 0);
		const data = toFormData(values);
		updateVehicleAd(vehicle.id, data);
		setRefresh();
		setEditModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="vehicleEditForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item
				label="Year"
				name={['vehicle', 'year']}
				initialValue={vehicle.year}
				rules={InputRules.required('Please select year!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a year">
					{years?.map((year) => (
						<Select.Option value={year} key={year}>
							{year}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Transmission"
				name={['vehicle', 'transmission']}
				rules={InputRules.required('Please select Transmission!')}
				initialValue={vehicle.transmission}
			>
				<Select showSearch allowClear={true} placeholder="Select a transmission">
					<Select.Option value="automatic">Automatic</Select.Option>
					<Select.Option value="manual">Manual</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item
				label="Interior Color"
				name={['vehicle', 'interiorColor']}
				initialValue={vehicle.interiorColor}
				rules={InputRules.required('Please select interior color!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a interior color">
					{utils?.colors?.map((color) => (
						<Select.Option value={color.name} key={color._id}>
							{color.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Exterior Color"
				name={['vehicle', 'exteriorColor']}
				initialValue={vehicle.exteriorColor}
				rules={InputRules.required('Please select exterior color!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a exterior color">
					{utils?.colors?.map((color) => (
						<Select.Option value={color.name} key={color._id}>
							{color.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Body Type"
				name={['vehicle', 'bodyType']}
				rules={InputRules.required('Please select body type!')}
				initialValue={vehicle.bodyType}
			>
				<Select showSearch allowClear={true} placeholder="Select a body type">
					{utils?.bodyTypes?.map((bodyType) => (
						<Select.Option value={bodyType._id} key={bodyType._id}>
							{bodyType._id}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Description"
				name={['vehicle', 'description']}
				rules={InputRules.required('Please select description!')}
				initialValue={vehicle.description}
			>
				<Input.TextArea rows={4}></Input.TextArea>
			</Form.Item>
			<Form.Item label="Custom Features" name={['vehicle', 'customFeatures']} initialvalues={vehicle.customFeatures}>
				<Select showSearch allowClear={true} placeholder="Select a custom features" mode="multiple">
					{utils?.features?.map(
						(feature) =>
							feature._id === 'Car Features' &&
							feature?.features?.map((feature) => (
								<Select.Option value={feature} key={feature}>
									{feature}
								</Select.Option>
							))
					)}
				</Select>
			</Form.Item>
			<Form.Item label="Price" name={['vehicle', 'price']} initialValue={vehicle.price}>
				<InputNumber />
			</Form.Item>
			<Form.Item label="Fuel Average" name={['vehicle', 'average']} initialValue={vehicle.average}>
				<InputNumber />
			</Form.Item>
			<Form.Item label="Upload Images" name="images" initialValue={vehicle.images}>
				<Upload
					multiple
					accept=".jpg,.png,.jpeg"
					listType="picture-card"
					onChange={handleChange}
					fileList={filelist}
					beforeUpload={() => false}
				>
					{uploadButton}
				</Upload>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Vehicle
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({
	utils: store.vehicleUtil.utils,
});

const mapDispatchToProps = (dispatch) => ({
	fetchVehicleUtils: () => dispatch(Actions.fetchVehicleUtils()),
	updateVehicleAd: (id, body) => dispatch(Actions.updateVehicleAd(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleEditForm);
